import { useQuery } from "@tanstack/react-query";
import api, { timeAgo } from "@/lib/api";
import { IngestionRun } from "@/lib/types";
import { PageHeader, Table, StatusBadge } from "@/admin/ui";

export default function Runs() {
  const { data } = useQuery({
    queryKey: ["admin-runs"],
    queryFn: async () => (await api.get("/admin/ingestion/runs")).data,
    refetchInterval: 15000,
  });

  return (
    <div data-testid="admin-runs-page">
      <PageHeader title="Ingestion Runs" sub="Every automated and manual pipeline execution (auto-refreshes)" />
      <Table headers={["Source", "Trigger", "Status", "Fetched", "Created", "Dupes", "Review", "Failed", "Started"]}>
        {(data?.items || []).map((r: IngestionRun) => (
          <tr key={r.id} data-testid={`run-row-${r.id}`}>
            <td className="px-4 py-2.5 text-white">{r.source_name}</td>
            <td className="px-4 py-2.5 font-mono text-xs text-gray-400">{r.triggered_by}</td>
            <td className="px-4 py-2.5"><StatusBadge status={r.status} /></td>
            <td className="px-4 py-2.5 font-mono text-gray-300">{r.fetched_count}</td>
            <td className="px-4 py-2.5 font-mono text-green-400">{r.created_count}</td>
            <td className="px-4 py-2.5 font-mono text-gray-500">{r.duplicate_count}</td>
            <td className="px-4 py-2.5 font-mono text-yellow-400">{r.review_count}</td>
            <td className="px-4 py-2.5 font-mono text-red-400">{r.failed_count}</td>
            <td className="px-4 py-2.5 font-mono text-xs text-gray-500">{timeAgo(r.started_at)}</td>
          </tr>
        ))}
      </Table>
      {(data?.items || []).length === 0 && (
        <p className="text-gray-500 text-sm mt-4">No runs yet — the scheduler kicks in shortly after startup, or trigger one from Sources.</p>
      )}
    </div>
  );
}
